import React from "react";
import { Icon, mergeStyles, Theme, useTheme } from "@fluentui/react";
import { svgIconStyle } from "../../styles";

interface ControlBarIconProps {
    disabled: boolean;
}

export const MicrophoneIconOn = (props: ControlBarIconProps): JSX.Element => {
    const themeV8 = useTheme();
    return (<Icon
        iconName="ControlButtonMicOn"
        className={mergeStyles({
            svg: svgIconStyle(themeV8, props.disabled)
        })}
    />);
}

export const MicrophoneIconOff = (props: ControlBarIconProps): JSX.Element => {
    const themeV8 = useTheme();
    return (<Icon
        iconName="ControlButtonMicOff"
        className={mergeStyles({
            svg: svgIconStyle(themeV8, props.disabled)
        })}
    />);
}


export const CameraIconOn = (props: ControlBarIconProps): JSX.Element => {
    const themeV8 = useTheme();
    return (<Icon
        iconName="ControlButtonCameraOn"
        className={mergeStyles({
            svg: svgIconStyle(themeV8, props.disabled)
        })}
    />);
}

export const CameraIconOff = (props: ControlBarIconProps): JSX.Element => {
    const themeV8 = useTheme();
    return (<Icon
        iconName="ControlButtonCameraOff"
        className={mergeStyles({
            svg: svgIconStyle(themeV8, props.disabled)
        })}
    />);
}

export const EndCallIcon = (): JSX.Element => {
    const themeV8 = useTheme();
    const disabled = false;

    return (<Icon
        iconName="ControlButtonEndCall"
        className={mergeStyles({
            svg: svgIconStyle(themeV8, disabled)
        })}
    />);
}
